module.exports = __webpack_public_path__ + "img/sikker-handel-2.a6aab9a6.png";